const ccParamFiles = [
    'ccParam01.js',
    'ccParam02.js',
    'ccParam03.js'
]

const awsParamFiles = [
    'awsParam01.js',
    'awsParam02.js',
    'awsParam03.js',
    'awsParam04.js',
    'awsParam05.js',
    'awsParam06.js'
]

export function setParams (storage) {
    const paramFile = (storage === 'cc') ? ccParamFiles : awsParamFiles
    const params = paramFile.map(file => {
        const { Payload, Desc } = require(`./${file}`)
        return {
            payload: Payload,
            desc: Desc
        }
    })
    return params
}
